import {get} from "../../util/request";

export interface ITenantSimpleListResponse {
  tenant_id: string
  name: string
}
export const tenantSimpleList = () => {
  return get<ITenantSimpleListResponse[]>({url: "/api/tenants/simple-list"})
}
